/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-03 11:10:48
 * @LastEditors Cong Yuan wso2848303@163.com
 * @LastEditTime 2025-06-04 17:17:06
 * @Description: store
 * @FilePath: /hsylc2021/src/store/index.js
 */
import Vue from 'vue';
import Vuex from 'vuex';
import Student from './student';
import Volunteer from './volunteer';
import LoginStore from './login';
import Region from './region';
import Deadline from './deadline';
import Plat from '../utils/plat';
import Form from './form';
import Locale from './locale';

Vue.use(Vuex);
/**p
 * @module Vuex
 */
export default new Vuex.Store({
  /**
   * @param {Object} studentLoginData 学生登录数据
   * @param {Object} schoolLoginData 学校登录数据
   */
  state: {
    StuProcess: null, // 学生申状态 数据
    ...LoginStore.states,
    // 学生申请
    ...Student.state,
    // 志愿者申请
    ...Volunteer.state,
    // 是否新生
    isNew: false,
    isCanCapstone: false,
    isAMCSite: Plat.isAMCSite
  },
  getters: {
    getIsCanCapstone: state => {
      return state.isCanCapstone;
    },
    getIsNewStudent: state => {
      return state.isNew;
    },
    // 获取 学生 申请表 状态 数据
    getStuApplyStatus: state => {
      return state.StuProcess;
    },
    ...LoginStore.getters,
    /************ 学生申请 *************/
    ...Student.getters,
    /************ 志愿者申请 *************/
    ...Volunteer.getters
  },
  mutations: {
    setIsCanCapstone: (state, data) => {
      state.isCanCapstone = data;
    },
    setIsNewStudent: (state, data) => {
      state.isNew = data;
    },
    // 设置Stu 申请表 状态 数据
    setStuProcess: (state, data) => {
      state.StuProcess = data;
    },
    ...LoginStore.mutations,
    /************ 学生申请 *************/
    ...Student.mutations,
    /************ 志愿者申请 *************/
    ...Volunteer.mutations
  },
  actions: {
    setIsCanCapstone: ({ commit }, data) => {
      commit('setIsCanCapstone', data);
    },
    setIsNewStudent: ({ commit }, data) => {
      commit('setIsNewStudent', data);
    },
    // 设置Stu 申请表 状态 数据
    setStuProcess: ({ commit }, data) => {
      commit('setStuProcess', data);
    },
    ...LoginStore.actions,
    /************ 学生申请 *************/

    ...Student.actions,
    /************ 志愿者申请 *************/
    ...Volunteer.actions
  },
  modules: {
    Region,
    Deadline,
    Form,
    Locale
  }
});
